/**
 * Visible FAQs, keyed by page path. The page renders them from here and schema.ts emits
 * FAQPage from the same data, so markup and page text cannot drift apart. Only add a page
 * here if the questions and answers are actually visible on it.
 */
export type Faq = { q: string; a: string };

export const faqsByPath: Record<string, Faq[]> = {
  '/patients': [
    {
      q: 'Who will be my doctor in the hospital?',
      a: "You'll be cared for by one of our experienced hospitalist physicians who specialize in inpatient care. They'll coordinate with your primary care doctor and any specialists involved in your care.",
    },
    {
      q: 'Will my primary care doctor know about my hospital stay?',
      a: 'Yes! We communicate regularly with your primary care physician throughout your stay and provide detailed discharge summaries to ensure continuity of care.',
    },
    {
      q: 'What if I have questions after I go home?',
      a: 'Our transitional care team will call you within 48 hours of discharge. You can also reach out to us anytime with questions or concerns about your recovery.',
    },
    {
      q: 'Is there a cost for transitional care services?',
      a: "No! Our transitional care program is provided at no additional cost to you. It's part of our commitment to ensuring your successful recovery.",
    },
  ],
};
